import React from "react";
import { ChatBubbleLeftIcon, InformationCircleIcon } from "@heroicons/react/24/solid";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { CalendarIcon } from "@heroicons/react/16/solid";
import { useNavigate } from 'react-router-dom';

const ModalAcceptationAffaire = ({ idAffaire, type, onClose }) => {
    const navigate = useNavigate();

    const Acceptation = async () => {
    
        const payload = {
            idAffaire: idAffaire,
            type: type,
            timestamp: new Date().toISOString()
        };
    
        //console.log("📩 Données envoyées :", JSON.stringify(payload, null, 2));

        fetch(`https://hooks.zapier.com/hooks/catch/7206204/2wnqil2/`, {
            method: "POST",
            "Content-Type": "application/json",
            body: JSON.stringify(payload),
        })
        .then(async (response) => {
            if (!response.ok) {
                throw new Error(`HTTP Error! Statut : ${response.status}`);
            }
            if(response.status === 200){
                if(type === "immo"){
                    navigate("/app/affaire/immo/" + idAffaire)
                }else if(type === "pma"){
                    navigate("/app/affaire/pma/" + idAffaire)
                }else if(type === "mariage"){
                    navigate("/app/affaire/mariage/" + idAffaire)
                }else if(type === "aucune_demarche"){
                    navigate("/app/affaire/aucune_demarche/" + idAffaire)
                }
                
            }
            //console.log("reponse acceptation",response);
        })
        .catch((error) => {
            console.error("❌ Erreur lors de l'envoi à Zapier :", error);
            alert("🚨 Une erreur est survenue lors de l'envoi des données.");
        });
        
    };




    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg  w-full max-w-4xl ">
                <h2 className="text-lg font-semibold mb-4">
                    <span role="img">🚀</span> Félicitations ! Vous avez une nouvelle affaire
                </h2>
                <div className="text-left">
                    <p className="text-base my-8"> Quelques conseils pour traiter cette affaire </p>
                    <ul className=" mt-16  p-0 m-0 divide-y divide-gray-100">
                        <li className="flex gap-x-4 py-2 text-left">
                            <ChatBubbleLeftIcon className="size-12 flex-none rounded-full text-indigo-200" />
                            <div className="min-w-0">
                                <p className="text-base font-semibold text-gray-900 mb-0">Utilisez Clotere pour échanger avec votre client</p>
                                <p className="mt-1  text-base text-gray-500 break-words whitespace-normal">On sait que vous adorez les mails, mais en utilisant la messagerie Clotere, nous nous occuperons des relances pour vous.</p>
                            </div>
                        </li>
                        <li className="flex gap-x-4 py-2 text-left">
                            <CalendarIcon className="size-12 flex-none rounded-full text-indigo-200" />
                            <div className="min-w-0">
                                <p className="text-base font-semibold text-gray-900 mb-0">Fixez vos rendez-vous de signature sur Clotere</p>
                                <p className="mt-1  text-base text-gray-500 break-words whitespace-normal">N'hésitez pas à utiliser notre fonctionnalité "Prise de rendez-vous" pour trouver un créneau commun rapidement et simplement.</p>
                            </div>
                        </li>
                        <li className="flex gap-x-4 py-2 text-left">
                            <QuestionMarkCircleIcon className="size-12 flex-none rounded-full text-indigo-200" />
                            <div className="min-w-0">
                                <p className="text-base font-semibold text-gray-900 mb-0">Et si j'ai une question ? </p>
                                <p className="mt-1  text-base text-gray-500 break-words whitespace-normal">
                                    Nous sommes à votre disposition pour toutes vos questions, via le chat en bas à droite de votre écran ou par mail ou whatsapp.
                                </p>
                            </div>
                        </li>
                    </ul>
                    {/** affichage du message sur les commissions si affaire immo */}
                    {type === "immo" &&
                        <>
                            <div className="rounded-md bg-blue-50 p-4">
                                <div className="flex">
                                    <div className="shrink-0">
                                        <InformationCircleIcon aria-hidden="true" className="size-5 text-blue-400" />
                                    </div>
                                    <div className="ml-3 flex-1 md:flex md:justify-between">
                                        <p className="text-sm text-blue-700 break-words whitespace-normal">Conformément à nos conditions générales de vente, des frais de service de 300€ HT vous seront facturés à la clôture de cette affaire.</p>
                                        <p className="mt-3 text-sm md:mt-0 md:ml-6">
                                            <a href="https://notaire.clotere.fr/cgv" target="blank" className="font-medium whitespace-nowrap text-blue-700 hover:text-blue-600">
                                                En savoir plus
                                                <span aria-hidden="true"> &rarr;</span>
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
                <button
                    onClick={Acceptation}
                    className="mt-4 px-4 py-2 bg-indigo-500 text-white rounded hover:bg-indigo-700"
                >
                    Ok
                </button>
            </div>
        </div>
    );
};

export default ModalAcceptationAffaire;